// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"2a932e36","845":"60cb6a26"}[chunkId] + ".chunk.js";
};